<template>
  <ReviewModal
    :venue-name="name"
    :venue-id="id"
    @track="onTrackReviewsModal"
  />
  <MapModal
    :map-config="{location_latitude: venueLocation.latitude, location_longitude: venueLocation.longitude}"
    :title="name"
  />
  <ReportVenueModal :venue-id="id" :venue-name="name" />
</template>

<script setup>
import MapModal from '@/modules/public/enquiry-form/components/MapModal.vue';
import ReviewModal from '@/modules/public/enquiry-form/components/ReviewModal/ReviewModal.vue';

import ReportVenueModal from './ReportVenueModal.vue';

const { id, name, venueLocation } = window.__VUE_DATA;

if (!window.__VUE_DATA || !id || !name || !venueLocation) {
  throw new Error('Venue ID, name, venueLocation are required.');
}

const onTrackReviewsModal = (data) => {
  App.track.event('venue_page_interaction', data);
};
</script>
